import React, { useState } from 'react';

function AutocompleteObject({ options = [], onSelect }) {
  const [inputValue, setInputValue] = useState('');
  const [filtered, setFiltered] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [localOptions, setLocalOptions] = useState(options);

  const updateFiltered = (val, opts) => {
    const trimmedVal = val.trim().toLowerCase();

    const filteredOptions = trimmedVal
      ? opts.filter(opt =>
          opt.name.toLowerCase().includes(trimmedVal)
        )
      : [];

    const exactMatch = opts.some(
      opt => opt.name.toLowerCase() === trimmedVal
    );

    if (trimmedVal && !exactMatch) {
      filteredOptions.push({
        id: `new-${Date.now()}`, // unique ID
        name: `Add "${val}"`,
        isNew: true,
      });
    }

    setFiltered(filteredOptions);
  };

  const handleChange = (e) => {
    const val = e.target.value;
    setInputValue(val);
    updateFiltered(val, localOptions);
    setHighlightedIndex(-1);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      setHighlightedIndex(prev =>
        prev < filtered.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === 'ArrowUp') {
      setHighlightedIndex(prev =>
        prev > 0 ? prev - 1 : filtered.length - 1
      );
    } else if (e.key === 'Enter') {
      if (highlightedIndex >= 0) {
        handleSelect(filtered[highlightedIndex]);
      }
    } else if (e.key === 'Escape') {
      setFiltered([]);
      setHighlightedIndex(-1);
    }
  };

  const handleSelect = (item) => {
    let selectedItem = item;

    if (item.isNew) {
      // create new object
      selectedItem = {
        id: String(Date.now()),
        name: inputValue.trim(),
        phoneNumber: '',
      };
      setLocalOptions(prev => [...prev, selectedItem]);
    }

    setInputValue(selectedItem.name);
    setFiltered([]);
    setHighlightedIndex(-1);
    onSelect(selectedItem); // return full object
  };

  return (
    <div style={{ width: '100%', position: 'relative' }}>
      <input
        type="text"
        value={inputValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder="Type or add name..."
        className="form-control"
      />
      {filtered.length > 0 && (
        <ul
          style={{
            listStyle: 'none',
            margin: 0,
            padding: 0,
            position: 'absolute',
            width: '100%',
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            zIndex: 1000,
            maxHeight: 200,
            overflowY: 'auto',
          }}
        >
          {filtered.map((item, i) => (
            <li
              key={item.id}
              onClick={() => handleSelect(item)}
              style={{
                padding: '8px',
                cursor: 'pointer',
                backgroundColor: highlightedIndex === i ? '#f0f0f0' : '#fff',
              }}
            >
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default AutocompleteObject;
